import { LocalStorageService } from './../services/local-storage.service';
import { Company } from './../interfaces/company.model';
import { CompanyService } from './company.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs/Rx';


@Injectable()
export class CompanyDefaultGuard {

  constructor(
    private localStorageService: LocalStorageService,
    private companyService: CompanyService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    return new Promise((response, error) => {
      this.companyService.getUserCompanies().subscribe(
        (companies: Company[]) => {
          if (companies.length === 1) {
            this.localStorageService.set('company', companies[0].id);
            this.router.navigateByUrl('/panel');
            return response(false);
          }
          const defaultCompany = companies.find(company => company.default && company.default === true);
          if (defaultCompany) {
            this.router.navigateByUrl('/panel');
            return response(false);
          }
          response(true);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/company.default.guard.ts